import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { IDocuments } from "../../models/storeModels/IDocuments";
import { logout } from "../../features/auth";

const initialState: IDocuments = {
    documentsTableName: undefined,
    documents: undefined,
    documentsTypes: undefined,
    documentsDownloadingState: undefined,
    selectedDocumentsAreLoading: false,
    showNoDocumentsAreSelectedWarning: false
}

export const documentsSlice = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        setDocuments(state, action: PayloadAction<any>) {
            state.documents = action.payload
        },
        setDocumentsTableName(state, action: PayloadAction<any>) {
            state.documentsTableName = action.payload
        },
        setDocumentsTypes(state, action: PayloadAction<any>) {
            state.documentsTypes = action.payload
        },
        setDocumentsDownloadingState(state, action: PayloadAction<any>) {
            state.documentsDownloadingState = action.payload
        },
        setSelectedDocumentsAreLoading(state, action: PayloadAction<any>) {
            state.selectedDocumentsAreLoading = action.payload
        },
        setShowNoDocumentsAreSelectedWarning(state, action: PayloadAction<any>) {
            state.showNoDocumentsAreSelectedWarning = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const { setDocuments, setDocumentsTableName, setDocumentsTypes, setDocumentsDownloadingState,
    setSelectedDocumentsAreLoading, setShowNoDocumentsAreSelectedWarning } = documentsSlice.actions
export const documentsReducer = documentsSlice.reducer;
